import { useState, type FormEvent } from 'react';
import { Logo } from '../App';
import { ApiError, describeError } from '../api/client';
import { useAuth } from '../auth/AuthProvider';
import { Field, Notice } from '../components/ui';
import { useConnection } from '../lib/ConnectionProvider';

export function LoginPage() {
  const { signIn, offline } = useAuth();
  const { online } = useConnection();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    if (busy) return;

    setBusy(true);
    setError(null);

    try {
      await signIn(email, password);
    } catch (cause) {
      // Il server non distingue "email sconosciuta" da "password sbagliata", e
      // nemmeno noi: mostrare due messaggi diversi vanificherebbe la scelta.
      setError(
        cause instanceof ApiError && cause.status === 429
          ? 'Troppi tentativi. Riprova fra qualche minuto.'
          : describeError(cause),
      );
      setPassword('');
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login__box" onSubmit={onSubmit}>
        <div className="login__brand">
          <Logo size={72} />
          <h1 className="login__title">PietroChip</h1>
          <p className="muted">Restituzione dei transponder, banco per banco.</p>
        </div>

        {(!online || offline) && (
          <Notice tone="missing">
            Il server non risponde. Controlla la connessione e riprova.
          </Notice>
        )}

        <div className="card">
          <div className="card__body stack">
            <Field label="Email">
              {({ id, ...aria }) => (
                <input
                  {...aria}
                  id={id}
                  className="input"
                  type="email"
                  name="email"
                  autoComplete="username"
                  inputMode="email"
                  autoCapitalize="none"
                  autoCorrect="off"
                  required
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              )}
            </Field>

            <Field label="Password">
              {({ id, ...aria }) => (
                <input
                  {...aria}
                  id={id}
                  className="input"
                  type="password"
                  name="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              )}
            </Field>

            {error && <Notice tone="danger">{error}</Notice>}

            <button type="submit" className="btn btn--primary btn--lg btn--block" disabled={busy}>
              {busy ? 'Accesso in corso…' : 'Accedi'}
            </button>
          </div>
        </div>

        <p className="faint" style={{ textAlign: 'center', fontSize: '0.8125rem' }}>
          Gli account si creano dall’interno, da un amministratore. Non esiste registrazione
          pubblica.
        </p>
      </form>
    </div>
  );
}
